import BreadcrumbsComponent from "../../components/Breadcrumbs/BreadcrumbsComponent";
import DetailInformation from "./DetailInformation";
import { Button } from "react-bootstrap";
import styles from "./PageProjectDetail.module.css";

export default function PageProjectDetail({ fundData, setSelectedFund }) {
  
  return (
    <div className="page-referals container-animated">
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <BreadcrumbsComponent params={fundData?.name ?? ""} />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <Button
          aria-label="return"
          className={styles.btnReturn}
          onClick={setSelectedFund}
        >
          <i class="bi bi-arrow-left-circle"></i>
        </Button>
        Detalles de {fundData?.name ?? ""}
      </div>
      <DetailInformation fundData={fundData} />
    </div>
  );
}
